import React from 'react';
import { CANCEL_PAGE_PATH, LEGAL_LINKS } from './brand.js';

const linkStyle: React.CSSProperties = { color: '#475569', textDecoration: 'underline' };

/**
 * Terms, privacy, withdrawal and the cancel link. The legal pages are German (hreflang says so);
 * "Verträge hier kündigen" is the law's name for the cancel button (§312k BGB).
 */
export const BillingLinks: React.FC<{ includeImprint?: boolean; align?: 'center' | 'start' }> = ({
  includeImprint = false,
  align = 'center',
}) => (
  <nav
    aria-label="Legal"
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: align === 'center' ? 'center' : 'flex-start',
      gap: '4px 14px',
      fontSize: 13,
    }}
  >
    <a
      href={LEGAL_LINKS.terms}
      target="_blank"
      rel="noopener noreferrer"
      hrefLang="de"
      style={linkStyle}
    >
      Terms
    </a>
    <a
      href={LEGAL_LINKS.privacy}
      target="_blank"
      rel="noopener noreferrer"
      hrefLang="de"
      style={linkStyle}
    >
      Privacy
    </a>
    <a
      href={LEGAL_LINKS.withdrawal}
      target="_blank"
      rel="noopener noreferrer"
      hrefLang="de"
      style={linkStyle}
    >
      Withdrawal
    </a>
    <a href={LEGAL_LINKS.refund} target="_blank" rel="noopener noreferrer" style={linkStyle}>
      Refund policy
    </a>
    {includeImprint && (
      <a
        href={LEGAL_LINKS.imprint}
        target="_blank"
        rel="noopener noreferrer"
        hrefLang="de"
        style={linkStyle}
      >
        Imprint
      </a>
    )}
    <a href={CANCEL_PAGE_PATH} lang="de" style={linkStyle}>
      Verträge hier kündigen
    </a>
  </nav>
);
